/**
 * Returns the browser URL for an environment image.
 * Prefers API-provided imageUrl; falls back to the env-thumb media endpoint.
 * Avoids mixed-content by upgrading/rebuilding http image hosts on https pages.
 * @param {Object} [item]
 * @returns {string|null}
 */
const getApiOrigin = () => {
    const imageUrl = (process.env.REACT_APP_IMAGE_URL || '').replace(/\/$/, '');
    if (imageUrl) {
        return imageUrl;
    }

    return (process.env.REACT_APP_BASE_URL || '')
        .replace(/\/$/, '')
        .replace(/\/api$/, '');
};

/**
 * @param {string} filename
 * @returns {string|null}
 */
const buildEnvThumbUrl = (filename) => {
    if (!filename) {
        return null;
    }

    const apiOrigin = getApiOrigin();
    if (!apiOrigin) {
        return null;
    }

    return `${apiOrigin}/api/media/env-thumb/${filename}`;
};

/**
 * @param {string} url
 * @returns {string}
 */
const preferSecureAssetUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return url;
    }

    const isBrowserHttps =
        typeof window !== 'undefined' && window.location?.protocol === 'https:';

    if (!isBrowserHttps || !url.startsWith('http://')) {
        return url;
    }

    const filename = url.split('/').pop();
    const rebuilt = buildEnvThumbUrl(filename);
    if (rebuilt && !rebuilt.startsWith('http://')) {
        return rebuilt;
    }

    return `https://${url.slice('http://'.length)}`;
};

const getEnvironmentImageSrc = (item) => {
    if (!item) {
        return null;
    }

    if (item.imageUrl) {
        return preferSecureAssetUrl(item.imageUrl);
    }

    if (!item.image) {
        return null;
    }

    const path = item.image.replace(/^\//, '');

    if (path.startsWith('http://') || path.startsWith('https://')) {
        const filename = path.split('/').pop();
        return preferSecureAssetUrl(buildEnvThumbUrl(filename) || path);
    }

    if (
        path.includes('env-thumb')
        || path.includes('environments/')
        || path.startsWith('public/uploads/')
    ) {
        const filename = path.split('/').pop();
        return preferSecureAssetUrl(buildEnvThumbUrl(filename));
    }

    const base = getApiOrigin();
    return preferSecureAssetUrl(base ? `${base}/${path}` : null);
};

export default getEnvironmentImageSrc;
